import { useRef } from "react";
import ModalPop from "../../home/ModalPop";

const RightQuick = () => {
  const popupRef = useRef<HTMLDivElement>(null);

  const openfunc = () => {
    popupRef.current!.style.display = "block";
  };

  const closefunc = () => {
    popupRef.current!.style.display = "none";
  };
  return (
    <>
      <ModalPop popupRef={popupRef} closefnc={closefunc} />
      <div className="fixed right-2 bottom-16 lg:bottom-auto lg:right-10 lg:top-1/3 lg:-translate-y-20 w-fit h-fit z-10">
        <div className="grid grid-rows-3 gap-2 lg:gap-5">
          <button
            type="button"
            onClick={() => window.open("https://open.kakao.com/o/scbfZxci")}
            className=" relative w-fit h-fit max-w-16 lg:max-w-24 hover:-translate-y-3 transition-transform duration-200 hover:shadow-md rounded-full"
          >
            <img
              src="/images/iconKakao.png"
              alt="집치워드림센터 카카오톡 상담 바로가기"
              className="!relative w-full h-full object-contain"
            />
          </button>
          <button
            type="button"
            onClick={() => window.open("https://blog.naver.com/ranger9591")}
            className=" relative w-fit h-fit max-w-16 lg:max-w-24 hover:-translate-y-3 transition-transform duration-200 hover:shadow-md rounded-full"
          >
            <img
              src="/images/iconBlog.png"
              alt="집치워드림센터 네이버 블로그 바로가기"
              className="!relative w-full h-full object-contain"
            />
          </button>
          <button
            type="button"
            onClick={openfunc}
            className=" relative w-fit h-fit max-w-16 lg:max-w-24 hover:-translate-y-3 transition-transform duration-200 hover:shadow-md rounded-full"
          >
            <img
              src="/images/iconContact.png"
              alt="집치워드림센터 무료 출장견적 문의하기"
              className="!relative w-full h-full object-contain"
            />
          </button>
        </div>
      </div>
    </>
  );
};

export default RightQuick;
